export enum IresaPaymentModeEnum {
    INTERNET_CARTE_BLEUE = "INTERNET CARTE BLEUE", // NL, FR systempay
    INTERNET_CARTE_VISE = "INTERNET CARTE VISA", // NL, FR systempay
    INTERNET_MASTERCARD = "INTERNET MASTERCARD", // NL, FR systempay
    INTERNET_CARTE_AMEX = "INTERNET CARTE AMEX", // NL, FR systempay
    STRIPE_CREDIT_CARD_UK = "STRIPE CREDIT CARD UK", // STRIPE UK
    STRIPE_CREDIT_CARD_NL = "STRIPE", // STRIPE NL
    IDEAL = "SNOWTIME IDEAL",
    BANCONTACT = "STRIPE BANCONTACT",
    BANCONTACT_NL = "STRIPE BANCONTACT NL",
}

// Payment modes that can be scheduled
export const StripeScheduledPaymentModesEnum = [
    IresaPaymentModeEnum.STRIPE_CREDIT_CARD_UK,
    IresaPaymentModeEnum.STRIPE_CREDIT_CARD_NL,
]

export const SystempayScheduledPaymentModesEnum = [
    IresaPaymentModeEnum.INTERNET_CARTE_BLEUE,
    IresaPaymentModeEnum.INTERNET_CARTE_VISE,
    IresaPaymentModeEnum.INTERNET_MASTERCARD,
    IresaPaymentModeEnum.INTERNET_CARTE_AMEX,
]

// adyen support all payment modes, so we need to add all possible payment modes to the list
export const AdyenScheduledPaymentModesEnum = [
    IresaPaymentModeEnum.INTERNET_CARTE_BLEUE,
    IresaPaymentModeEnum.INTERNET_CARTE_VISE,
    IresaPaymentModeEnum.INTERNET_MASTERCARD,
    IresaPaymentModeEnum.INTERNET_CARTE_AMEX,
    IresaPaymentModeEnum.STRIPE_CREDIT_CARD_NL,
    IresaPaymentModeEnum.STRIPE_CREDIT_CARD_UK,
]